import BaseService from "../base.service";

const API_URL = process.env.VUE_APP_API_URL;

class LiveStreamService extends BaseService {
  getLinkLiveStream(streamId) {
    const payload = {
      stream_id: streamId,
    };

    return this.post(`${API_URL}/api/stream`, payload)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  }
}

export default new LiveStreamService();
